import { notifications } from "@mantine/notifications";
import { IconAlertCircle, IconCircleCheck } from "@tabler/icons-react";
import React, { useEffect, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { url } from "../../settings/linkUrl";


export default function CheckAuthen() {
  const nav = useNavigate();
  let { id_no, dd, mm, yy } = useParams();
  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const funcSubmit = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const bdate = `${dd}/${mm}/${yy}`;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },

      body: JSON.stringify({
        id_no: id_no,
        bdate: bdate,
      }),
    };
    fetch(`${url}user/login_student`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.data.success === "1") {
          localStorage.setItem("token", json.data.auth);
          funcPermission();
        } else if (json.data.success === "0") {
          nav("/");
          notifications.show({
            title: "แจ้งเตือน",
            message:
              "ไม่สามารถเข้าระบบได้ กรุณาตรวจสอบข้อมูลผู้ใช้ใหม่อีกครั้ง",
            autoClose: 3000,
            color: "red",
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const funcPermission = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}user/premission`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        console.log(json);
        if (json.data.success === "1") {
          localStorage.setItem("dataUser", JSON.stringify(json.data.data));
          notifications.show({
            title: "เข้าระบบสำเร็จ",
            message: "กรุณารอสักครู่ กำลังเข้าหน้าผู้ใช้งาน",
            autoClose: 3000,
            icon: <IconCircleCheck />,
            color: "green",
          });
          nav("/dashboard");
        } else if (json.data.success === "0") {
          nav("/");

          notifications.show({
            title: "แจ้งเตือน",
            message:
              "ไม่สามารถเข้าระบบได้ กรุณาตรวจสอบข้อมูลผู้ใช้ใหม่อีกครั้ง",
            autoClose: 3000,
            color: "red",
            icon: <IconAlertCircle />,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    funcSubmit();
  }, []);

  return <div></div>;
}
